
                import "css-modules://src_components_imagepair"
                export default {"Main":"_43dc2f","TopPadding":"_fab50e","RightAligned":"_e2338f","Left":"_0e1a4d","Right":"_d3499d"}
            